"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  if (!("scrollbars" in theme)) {
    theme.scrollbars = {
      main: {}
    };
  }

  return {
    wrapper: {
      marginBottom: theme.spacing(4),
      marginTop: theme.spacing(1)
    },
    icon: {
      lineHeight: 0
    },
    iconIsActive: {
      color: theme.palette.primary.main
    }
  };
};

exports.styles = styles;